import { useImpersonationStore } from "@/store/useImpersonationStore";
import { useSessionStore } from "@/store/sessionStore/sessionStore";

// Hook to get the active session data in reactive components
export function useActiveSession() {
  const session = useSessionStore();
  const impersonation = useImpersonationStore();

  if (impersonation.isImpersonating) {
    return {
      ...session,
      userId: impersonation.userId,
      tenantId: impersonation.tenantId,
      email: impersonation.email,
      firstName: impersonation.firstName,
      lastName: impersonation.lastName,
      userType: impersonation.userType,
      isEntityLogin: impersonation.isEntityLogin ?? false,
      isMainAppLogin: impersonation.isMainAppLogin ?? false,
      subDomain: impersonation.subDomain,
      modules: impersonation.modules ?? [],
      userName: impersonation.userName,
      userRoles: impersonation.userRoles ?? [],
      entityName: impersonation.entityName,
      isAppLevel: impersonation.isAppLevel ?? false,
      allEntities: impersonation.allEntities ?? false,
      entityIds: impersonation.entityIds ?? [],
    };
  }

  return session;
}

// Non reactive function to get the active session data in non-reactive components
export function getActiveSessionState() {
  const session = useSessionStore.getState();
  const impersonation = useImpersonationStore.getState();

  if (impersonation.isImpersonating) {
    return {
      ...session,
      userId: impersonation.userId,
      tenantId: impersonation.tenantId,
      email: impersonation.email,
      firstName: impersonation.firstName,
      lastName: impersonation.lastName,
      userType: impersonation.userType,
      isEntityLogin: impersonation.isEntityLogin ?? false,
      isMainAppLogin: impersonation.isMainAppLogin ?? false,
      subDomain: impersonation.subDomain,
      modules: impersonation.modules ?? [],
      userName: impersonation.userName,
      userRoles: impersonation.userRoles ?? [],
      entityName: impersonation.entityName,
      isAppLevel: impersonation.isAppLevel ?? false,
      allEntities: impersonation.allEntities ?? false,
      entityIds: impersonation.entityIds ?? [],
    };
  }

  return session;
}
